import ArrowRight from 'assets/svg/arrow/arrow_right.svg'
import Flex from 'common/components/Flex'
import theme from 'common/theme'
import { useState } from 'react'
import styled from 'styled-components'

const PerusahaanContainer = styled(Flex)`
  background: transparent;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  text-wrap: nowrap;
  min-width: 147px;
  gap: 8px;
`

const LeftMenuSection = styled.div`
  flex: 1;
  background: #f8f9fa;
  padding: 16px;
`

const RightMenuSection = styled.div`
  flex: 1;
  background: #f8f9fa;
  padding: 16px;
  transition: opacity 0.3s ease;
  display: ${({ show }) => (show ? 'inline-block' : 'none')};
  min-width: 200px;
`

const MenuCategory = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`

const MenuItemLink = styled.a`
  ${theme.typography.rsubtitle}
  display: flex;
  padding: 12px;
  margin-bottom: 4px;
  align-items: center;
  color: ${theme.colors.black};
  border-radius: 8px;
  cursor: pointer;
  background-color: transparent;
  font-weight: ${({ active }) => (active ? 700 : 400)};
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    font-weight: 700;
    background-color: ${theme.colors.grayLighter};
  }
`

const RightMenuItem = styled.a`
  ${theme.typography.rsubtitle}
  display: flex;
  padding: 12px;
  margin-bottom: 8px;
  align-items: center;
  color: ${theme.colors.black};
  border-radius: 8px;
  cursor: pointer;
  background-color: transparent;
  font-weight: 400;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    font-weight: 700;
    background-color: ${theme.colors.grayLighter};
  }
`

const ArrowIcon = styled(ArrowRight)`
  transform: scale(0.5);
  margin-left: 8px;
  fill: black;
`

// Configuration object for menu items and their corresponding right sections
const MENU_CONFIG = {
  marketplace: {
    title: 'Marketplace',
    url: '#',
    hasSubmenu: true,
    submenuItems: [
      {
        name: 'Ralali Tender',
        url: 'https://www.ralali.com/tender',
      },
      {
        name: 'Ralali Billing',
        url: 'https://www.ralali.com/billing',
      },
      {
        name: 'Ralali Pavilion',
        url: 'https://www.ralali.com/pavilion',
      },
      {
        name: 'Online Invoice',
        url: 'https://www.ralali.com/online-invoice',
      },
    ],
  },
  ralaliplus: {
    title: 'Ralaliplus',
    url: '#',
    hasSubmenu: true,
    submenuItems: [
      {
        name: 'Invoice Financing',
        url: 'https://www.ralali.com/solutions/plus/invoice',
      },
      {
        name: 'Inventory Financing',
        url: 'https://www.ralali.com/solutions/plus/inventory',
      },
      {
        name: 'Purchase Order Financing',
        url: 'https://www.ralali.com/solutions/plus/purchase-order',
      },
      {
        name: 'Working Capital',
        url: 'https://www.ralali.com/solutions/plus/working-capital',
      },
      {
        name: 'Terms Loan',
        url: 'https://www.ralali.com/solutions/plus/terms-loan',
      },
      {
        name: 'Lihat Semua',
        url: 'https://www.ralali.com/solutions/plus',
      },
    ],
  },
  ralalifood: {
    title: 'Ralalifood',
    url: '#',
    hasSubmenu: true,
    submenuItems: [
      {
        name: 'Lanana',
        url: 'https://www.ralali.com/food/lanana',
      },
      {
        name: 'OEM & Maklon',
        url: 'https://www.ralali.com/food/',
      },
      {
        name: 'Minasoku',
        url: 'https://www.ralali.com/food/minasoku',
      },
      {
        name: 'Lihat Semua',
        url: 'https://www.ralali.com/food',
      },
    ],
  },
}

interface IBusinessSolutionsPopoverProps {
  menuConfig?: typeof MENU_CONFIG
}

const BusinessSolutionsPopover = ({
  menuConfig = MENU_CONFIG,
}: IBusinessSolutionsPopoverProps): JSX.Element => {
  const [activeRightMenu, setActiveRightMenu] = useState<string>('')

  const handleMenuHover = (menuKey: string) => {
    const menuItem = menuConfig[menuKey]
    if (menuItem?.hasSubmenu) {
      setActiveRightMenu(menuKey)
    } else {
      setActiveRightMenu('')
    }
  }

  const handleMouseLeave = () => {
    setActiveRightMenu('')
  }

  // Get active submenu items
  const activeSubmenuItems =
    activeRightMenu && menuConfig[activeRightMenu]
      ? menuConfig[activeRightMenu].submenuItems
      : []

  // Check if any menu has active right section
  const showRightSection =
    activeRightMenu && activeSubmenuItems.length > 0

  return (
    <PerusahaanContainer onMouseLeave={handleMouseLeave}>
      <LeftMenuSection>
        <MenuCategory>
          {Object.entries(menuConfig).map(([key, config]) => (
            <MenuItemLink
              key={key}
              onMouseEnter={() => handleMenuHover(key)}
              href={config.url}
              active={activeRightMenu === key}
            >
              {config.title}
              {config.hasSubmenu && <ArrowIcon />}
            </MenuItemLink>
          ))}
        </MenuCategory>
      </LeftMenuSection>

      <RightMenuSection show={showRightSection}>
        {activeSubmenuItems.map((item) => (
          <RightMenuItem key={item.name} href={item.url}>
            {item.name}
          </RightMenuItem>
        ))}
      </RightMenuSection>
    </PerusahaanContainer>
  )
}

export default BusinessSolutionsPopover
export { MENU_CONFIG }
